import EventActivityVue from '@/views/member/event-activity/event-activity.vue';

const basePath = '/member/event-activity';
const role = 'member'; // 角色身份

export const M_EVENT_ACTIVITY_INDEX = 'm-event-activity-index';
export const M_EVENT_ACTIVITY_CREATE = 'm-event-activity-create';
export const M_EVENT_ACTIVITY_SUCCESS = 'm-event-activity-success';
export const M_EVENT_ACTIVITY_EDIT = 'm-event-activity-edit';
export const M_EVENT_ACTIVITY_PAYMENT = 'm-event-activity-payment';
export const M_EVENT_ACTIVITY_PAYMENT_STATUS = 'm-event-activity-payment-status';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: EventActivityVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: M_EVENT_ACTIVITY_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "event-activity-index" */
        `@/views/${role}/event-activity/index.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/create/:id`,
      name: M_EVENT_ACTIVITY_CREATE,
      props: true,
      component: () => import(
        /* webpackChunkName: "event-activity-create" */
        `@/views/${role}/event-activity/create.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/success`,
      name: M_EVENT_ACTIVITY_SUCCESS,
      component: () => import(
        /* webpackChunkName: "event-activity-success" */
        `@/views/${role}/event-activity/success.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:id`,
      name: M_EVENT_ACTIVITY_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "event-activity-create" */
        `@/views/${role}/event-activity/edit.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/payment`,
      name: M_EVENT_ACTIVITY_PAYMENT,
      props: true,
      component: () => import(
        /* webpackChunkName: "event-activity-create" */
        `@/views/${role}/event-activity/payment.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/paymentStatus/:id`,
      name: M_EVENT_ACTIVITY_PAYMENT_STATUS,
      props: true,
      component: () => import(
        /* webpackChunkName: "event-activity-create" */
        `@/views/${role}/event-activity/paymentStatus.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
  ]
};
